// extracted by mini-css-extract-plugin
export var childrenContainer = "_bz-0";
export var virtualScrollArea = "_bz-1";